import AdaptiveQuizIndividualPage from './AdaptiveQuizIndividualPage';

export default AdaptiveQuizIndividualPage;
